import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMusicPlayer } from '../context/MusicPlayerContext';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const { currentSong, isPlaying } = useMusicPlayer();

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Update browser tab title when song changes
  useEffect(() => {
    const baseTitle = 'SamaWeb Music';
    
    if (currentSong && isPlaying) {
      // Show playing indicator in tab title
      document.title = `🎵 ${currentSong.title || 'Playing'} - ${currentSong.artist || 'Unknown Artist'} | ${baseTitle}`;
    } else if (currentSong) {
      // Show paused song in tab title
      document.title = `⏸️ ${currentSong.title || 'Paused'} - ${currentSong.artist || 'Unknown Artist'} | ${baseTitle}`;
    } else {
      // Default title when no song is playing
      document.title = baseTitle;
    }

    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = baseTitle;
    };
  }, [currentSong, isPlaying]);

  return null;
};

export default ScrollToTop;